/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * IDF Repasses
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListProfessionalsEndpointApiProfessionalsGetParams,
  ProfessionalCreate,
  ProfessionalOut,
  ProfessionalUpdate
} from '../model';

import { apiClient } from '../../client';




/**
 * @summary List Professionals Endpoint
 */
export const listProfessionalsEndpointApiProfessionalsGet = (
    params?: ListProfessionalsEndpointApiProfessionalsGetParams,
 signal?: AbortSignal
) => {


      return apiClient<ProfessionalOut[]>(
      {url: `/api/professionals`, method: 'GET',
        params, signal
    },
      );
    }




export const getListProfessionalsEndpointApiProfessionalsGetQueryKey = (params?: ListProfessionalsEndpointApiProfessionalsGetParams,) => {
    return [
    `/api/professionals`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProfessionalsEndpointApiProfessionalsGetQueryOptions = <TData = Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError = HTTPValidationError>(params?: ListProfessionalsEndpointApiProfessionalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProfessionalsEndpointApiProfessionalsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>> = ({ signal }) => listProfessionalsEndpointApiProfessionalsGet(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProfessionalsEndpointApiProfessionalsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>>
export type ListProfessionalsEndpointApiProfessionalsGetQueryError = HTTPValidationError


export function useListProfessionalsEndpointApiProfessionalsGet<TData = Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListProfessionalsEndpointApiProfessionalsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>,
          TError,
          Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfessionalsEndpointApiProfessionalsGet<TData = Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError = HTTPValidationError>(
 params?: ListProfessionalsEndpointApiProfessionalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>,
          TError,
          Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfessionalsEndpointApiProfessionalsGet<TData = Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError = HTTPValidationError>(
 params?: ListProfessionalsEndpointApiProfessionalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Professionals Endpoint
 */

export function useListProfessionalsEndpointApiProfessionalsGet<TData = Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError = HTTPValidationError>(
 params?: ListProfessionalsEndpointApiProfessionalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfessionalsEndpointApiProfessionalsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProfessionalsEndpointApiProfessionalsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Create Professional Endpoint
 */
export const createProfessionalEndpointApiProfessionalsPost = (
    professionalCreate: ProfessionalCreate,
 signal?: AbortSignal
) => {


      return apiClient<ProfessionalOut>(
      {url: `/api/professionals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: professionalCreate, signal
    },
      );
    }



export const getCreateProfessionalEndpointApiProfessionalsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>, TError,{data: ProfessionalCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>, TError,{data: ProfessionalCreate}, TContext> => {

const mutationKey = ['createProfessionalEndpointApiProfessionalsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>, {data: ProfessionalCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProfessionalEndpointApiProfessionalsPost(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProfessionalEndpointApiProfessionalsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>>
    export type CreateProfessionalEndpointApiProfessionalsPostMutationBody = ProfessionalCreate
    export type CreateProfessionalEndpointApiProfessionalsPostMutationError = HTTPValidationError

    /**
 * @summary Create Professional Endpoint
 */
export const useCreateProfessionalEndpointApiProfessionalsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>, TError,{data: ProfessionalCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProfessionalEndpointApiProfessionalsPost>>,
        TError,
        {data: ProfessionalCreate},
        TContext
      > => {
      return useMutation(getCreateProfessionalEndpointApiProfessionalsPostMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Professional Endpoint
 */
export const updateProfessionalEndpointApiProfessionalsProfessionalIdPatch = (
    professionalId: number,
    professionalUpdate: ProfessionalUpdate,
 signal?: AbortSignal
) => {


      return apiClient<ProfessionalOut>(
      {url: `/api/professionals/${professionalId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: professionalUpdate, signal
    },
      );
    }



export const getUpdateProfessionalEndpointApiProfessionalsProfessionalIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>, TError,{professionalId: number;data: ProfessionalUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>, TError,{professionalId: number;data: ProfessionalUpdate}, TContext> => {

const mutationKey = ['updateProfessionalEndpointApiProfessionalsProfessionalIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>, {professionalId: number;data: ProfessionalUpdate}> = (props) => {
          const {professionalId,data} = props ?? {};

          return  updateProfessionalEndpointApiProfessionalsProfessionalIdPatch(professionalId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfessionalEndpointApiProfessionalsProfessionalIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>>
    export type UpdateProfessionalEndpointApiProfessionalsProfessionalIdPatchMutationBody = ProfessionalUpdate
    export type UpdateProfessionalEndpointApiProfessionalsProfessionalIdPatchMutationError = HTTPValidationError

    /**
 * @summary Update Professional Endpoint
 */
export const useUpdateProfessionalEndpointApiProfessionalsProfessionalIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>, TError,{professionalId: number;data: ProfessionalUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfessionalEndpointApiProfessionalsProfessionalIdPatch>>,
        TError,
        {professionalId: number;data: ProfessionalUpdate},
        TContext
      > => {
      return useMutation(getUpdateProfessionalEndpointApiProfessionalsProfessionalIdPatchMutationOptions(options), queryClient);
    }
